import { render, staticRenderFns } from "./PostTripInspection.vue?vue&type=template&id=02d6a2e7"
import script from "./PostTripInspection.vue?vue&type=script&lang=js"
export * from "./PostTripInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports